import { capitalize } from 'lodash';
import * as radiosGernesDetails from '../../assets/radios-gernes-and-details.json';

export class MiscUtils {
  public static beautifyGenres(tags: string): string {
    if (!tags) {
      return '';
    }
    return tags
      .trim()
      .replace(/ +/g, '')
      .split(',')
      .filter(Boolean)
      .map((tag) => capitalize(tag))
      .join(' ⚬ ');
  }

  public static formatKbps(kbps: number): string {
    if (kbps == null || kbps === 0) {
      return 'N/A';
    }
    return '' + kbps;
  }

  public static truncateChar(text: string, charlimit: number = 40): string {
    if (!text || text.length <= charlimit) {
      return text;
    }
    const withoutHtml = text.replace(/<(?:.|\n)*?>/gm, '');
    return withoutHtml.substring(0, charlimit) + '...';
  }

  public static toCategoryTitle(text: string): string {
    return this.toFirstLetterUpperCase(text).replace('And', 'and');
  }

  public static toFirstLetterUpperCase(text: string): string {
    return text
      .split(' ')
      .map((word) => word[0].toUpperCase() + word.substring(1))
      .join(' ');
  }

  public static encodeUrlComponent(text: string): string {
    return encodeURIComponent(text).replace(/\(/g, '%28').replace(/\)/g, '%29');
  }

  public static getDetailsForGerne(inputGerne: String): GerneDetails {
    const gerneDetails = new GerneDetails();
    const gerne = radiosGernesDetails.genres.find((x) => x.name == inputGerne);
    if (gerne != null) {
      gerneDetails.descriptionAndInterestingFact =
        gerne?.description + ' ' + gerne?.interesting_facts;
      gerneDetails.artistsAndBands = gerne.artists
        .map((a) => a.trim())
        .join(', ');
      gerneDetails.websites = gerne.websites;
    }
    return gerneDetails;
  }
}

class GerneDetails {
  descriptionAndInterestingFact = '';
  artistsAndBands = '';
  websites: string[] = [];
}
